import api from "../../config/base";
import {
  FETCH_CONFIGURATIONS_REQUEST,
  FETCH_CONFIGURATIONS_SUCCESS,
  FETCH_CONFIGURATIONS_FAILURE,
  FETCH_CONFIGURATION_REQUEST,
  FETCH_CONFIGURATION_SUCCESS,
  FETCH_CONFIGURATION_FAILURE,
  CREATE_CONFIGURATION_REQUEST,
  CREATE_CONFIGURATION_SUCCESS,
  CREATE_CONFIGURATION_FAILURE,
  UPDATE_CONFIGURATION_REQUEST,
  UPDATE_CONFIGURATION_SUCCESS,
  UPDATE_CONFIGURATION_FAILURE,
  DELETE_CONFIGURATION_REQUEST,
  DELETE_CONFIGURATION_SUCCESS,
  DELETE_CONFIGURATION_FAILURE,
  ACTIVE_CONFIGURATION_REQUEST,
  ACTIVE_CONFIGURATION_SUCCESS,
  ACTIVE_CONFIGURATION_FAILURE,
  DOWNLOAD_CONFIGURATION_REQUEST,
  DOWNLOAD_CONFIGURATION_SUCCESS,
  DOWNLOAD_CONFIGURATION_FAILURE,
  FETCH_MAX_EVENTID_REQUEST,
  FETCH_MAX_EVENTID_SUCCESS,
  FETCH_MAX_EVENTID_FAILURE,
  FETCH_ACTIVE_CONFIGURATION_ID_REQUEST,
  FETCH_ACTIVE_CONFIGURATION_ID_SUCCESS,
  FETCH_ACTIVE_CONFIGURATION_ID_FAILURE,
  FETCH_CONFIGURATIONS_BY_COMPANY_REQUEST,
  FETCH_CONFIGURATIONS_BY_COMPANY_SUCCESS,
  FETCH_CONFIGURATIONS_BY_COMPANY_FAILURE,
  FETCH_CONFIGURATIONS_BY_COUNTRY_REQUEST,
  FETCH_CONFIGURATIONS_BY_COUNTRY_SUCCESS,
  FETCH_CONFIGURATIONS_BY_COUNTRY_FAILURE,
  FETCH_CONFIGURATIONS_BY_USER_REQUEST,
  FETCH_CONFIGURATIONS_BY_USER_SUCCESS,
  FETCH_CONFIGURATIONS_BY_USER_FAILURE,

} from "./types";

// Fetch all configurations
export const fetchConfigurations = () => async (dispatch) => {
  dispatch({ type: FETCH_CONFIGURATIONS_REQUEST });
  try {
    const response = await api.get('/configurations');
    dispatch({ type: FETCH_CONFIGURATIONS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_CONFIGURATIONS_FAILURE, payload: error.message });
  }
};

// Fetch a single configuration
export const fetchConfiguration = (id) => async (dispatch) => {
  dispatch({ type: FETCH_CONFIGURATION_REQUEST });
  try {
    const response = await api.get(`/configurations/${id}`);
    dispatch({ type: FETCH_CONFIGURATION_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_CONFIGURATION_FAILURE, payload: error.message });
  }
};

// Create a new configuration
export const createConfiguration = (configData) => async (dispatch) => {
  dispatch({ type: CREATE_CONFIGURATION_REQUEST });
  console.log(configData)
  try {
    const response = await api.post('/configurations', configData);
    dispatch({ type: CREATE_CONFIGURATION_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: CREATE_CONFIGURATION_FAILURE, payload: error.message });
  }
};

// Update an existing configuration
export const updateConfiguration = (id, configData) => async (dispatch) => {
  dispatch({ type: UPDATE_CONFIGURATION_REQUEST });
  try {
    const response = await api.put(`/configurations/${id}`, configData);
    dispatch({ type: UPDATE_CONFIGURATION_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: UPDATE_CONFIGURATION_FAILURE, payload: error.message });
  }
};

// Delete a configuration
export const deleteConfiguration = (id) => async (dispatch) => {
  dispatch({ type: DELETE_CONFIGURATION_REQUEST });
  try {
    await api.delete(`/configurations/${id}`);
    dispatch({ type: DELETE_CONFIGURATION_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DELETE_CONFIGURATION_FAILURE, payload: error.message });
  }
};

// Activate a configuration
export const activateConfiguration = (id) => async (dispatch) => {
  dispatch({ type: ACTIVE_CONFIGURATION_REQUEST });
  try {
    const response = await api.put(`/configurations/active/${id}`);
    dispatch({ type: ACTIVE_CONFIGURATION_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: ACTIVE_CONFIGURATION_FAILURE, payload: error.message });
  }
};


// Download configuration by event ID
export const downloadConfigurationByEventId = (eventId) => async (dispatch) => {
  dispatch({ type: DOWNLOAD_CONFIGURATION_REQUEST });
  try {
    const response = await api.get(`/configurations/download/${eventId}`, {
      responseType: 'blob', // Ensure the response is treated as a blob for file download
    });

    // Create a URL for the file and trigger a download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `configuration_${eventId}.zip`); // Adjust the file name and extension as needed
    document.body.appendChild(link);
    link.click();
    link.remove();

    dispatch({ type: DOWNLOAD_CONFIGURATION_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: DOWNLOAD_CONFIGURATION_FAILURE, payload: error.message });
  }
};
// Fetch the most recent event ID
export const fetchMaxEventId = () => async (dispatch) => {
  dispatch({ type: FETCH_MAX_EVENTID_REQUEST });
  try {
    const response = await api.get(`/configurations/eventid/max`);
    dispatch({ type: FETCH_MAX_EVENTID_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_MAX_EVENTID_FAILURE, payload: error.message });
  }
};

// Fetch active configuration ID for a machine
export const fetchActiveConfigIdForMachine = (machineId) => async (dispatch) => {
  dispatch({ type: FETCH_ACTIVE_CONFIGURATION_ID_REQUEST });
  try {
    const response = await api.get(`/configurations/${machineId}/active`);
    dispatch({ type: FETCH_ACTIVE_CONFIGURATION_ID_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_ACTIVE_CONFIGURATION_ID_FAILURE, payload: error.message });
  }
};

// Fetch configurations by company
export const fetchConfigurationsByCompany = () => async (dispatch) => {
  dispatch({ type: FETCH_CONFIGURATIONS_BY_COMPANY_REQUEST });
  try {
    const response = await api.get(`/configurations/company`);
    dispatch({ type: FETCH_CONFIGURATIONS_BY_COMPANY_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_CONFIGURATIONS_BY_COMPANY_FAILURE, payload: error.message });
  }
};

// Fetch configurations by country
export const fetchConfigurationsByCountry = () => async (dispatch) => {
  dispatch({ type: FETCH_CONFIGURATIONS_BY_COUNTRY_REQUEST });
  try {
    const response = await api.get(`/configurations/country`);
    dispatch({ type: FETCH_CONFIGURATIONS_BY_COUNTRY_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_CONFIGURATIONS_BY_COUNTRY_FAILURE, payload: error.message });
  }
};

// Fetch configurations by user
export const fetchConfigurationsByUser = () => async (dispatch) => {
  dispatch({ type: FETCH_CONFIGURATIONS_BY_USER_REQUEST });
  try {
    const response = await api.get(`/configurations/user`);
    dispatch({ type: FETCH_CONFIGURATIONS_BY_USER_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_CONFIGURATIONS_BY_USER_FAILURE, payload: error.message });
  }
};
